<template>
  <div id="Servicios">
    <br /><br />
    <h1>Servicios</h1>
    <br />
    <div id="contenedor">
      <!-- inicio sección de servicios -->
      <div class="services-section">
        <article class="services-info">
          <a href="#/proveedores">
            <img
              class="services-info__imagen"
              src="../assets/recoleccion2.png"
              alt=""
          /></a>
          <h2 class="services-info__title">Recolección de materia prima</h2>
          <br />
          <p class="services-info__text">
            En este proceso realizamos la recolección de materia prima de
            nuestros proveedores para ayudar a reducir el impacto ambiental que
            causa la deforestación.
          </p>
        </article>
      </div>
      <article class="services-info">
        <a href="#/login">
          <img
            class="services-info__imagen"
            src="../assets/producciion1.png"
            alt=""
        /></a>
        <h2 class="services-info__title">Disponibilidad para la Producción</h2>
        <br />
        <p class="services-info__text">
          A través de esta plataforma se pueden
          realizar consultas sobre el material disponible para ser utilizado en la
          producción de papel y cartón 100% reciclado.
        </p>
      </article>
      <article class="services-info">
        <a href="#/Galeria">
        <img
          class="services-info__imagen"
          src="../assets/transformacion.png"
          alt=""
        /></a>
        <h2 class="services-info__title">Transformación final</h2>
        <br />
        <p class="services-info__text">
          La materia prima generada por nuestra empresa es aprovechada por
          nuestros clientes para la realización de diversos productos.
        </p>
      </article>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
#contenedor {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.services-section,
.seccion-noticias,
.seccion-equipo {
  display: flex;
  margin-bottom: 100px;
}

.seccion-noticias {
  flex-wrap: wrap;
}

.services-info {
  padding: 20px;
  text-align: center;
}

.news-info {
  width: 50%;
  padding: 20px;
  text-align: center;
}

.news-header {
  display: flex;
  justify-content: space-around;
}

.news-info__title {
  align-self: center;
}
.services-info__imagen {
  border-radius: 50%;
  margin-right: auto;
  margin-left: auto;
}

.team-info {
  width: 25%;
  padding: 15px;
  text-align: center;
}

.team-info__imagen {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
</style>

